import styled from '@emotion/styled';

export const MapWrapper = styled('div')(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flex: '60%',
  '@media(max-width: 768px)': {
    flex: 'unset',
  },
}));
